/**
 * Find drip item by contentPostId
 * @param {number|string} ID
 * @param {Array} dripItems
 * @returns {Object|null}
 */
export function getDripItem(ID, dripItems) {
  const targetId = Number(ID);

  return (
    dripItems.find(
      item => Number(item.contentPostId) === targetId
    ) || null
  );
}
